"use client";

import {useEffect, useState} from 'react';
import CustomImage from '@/components/image';
import styles from './_gc-reduction-cards.module.scss';
import Button from "@/components/button";

export default function HcpClinicalInformationGdReductionCards({
    tabIndex
  }) {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  useEffect(() => {
    setCurrentTabIndex(tabIndex);
  }, [tabIndex]);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <section className={styles.container}>
      <div className={styles.desktop_view}>
        <div className="container">
          <div className={styles.cards}>
            <div className={styles.card_wrapper}>
              <Button
                href="/clinical-information#trial-1-efficacy-link"
                data-gtm-event-category="Action"
                data-gtm-event-action="Click"
                data-gtm-event-label="CAHtalyst Pediatric GC Reduction Card"
              >
               <div className={`${styles.card} ${currentTabIndex === 1 && styles.card_white}`}>
                <div className={styles.title_group}>
                  <h3 className={styles.trial_title}>CAHtalyst<sup>&reg;</sup> Pediatric: <br/>Personalized GC Dose Reduction<sup>1,6,9</sup>
                  </h3>
                </div>
                <div className={styles.content_wrapper}>
                  <ul className={styles.questions}>
                    <li className={styles.question}>
                      <strong>Question 1:</strong> Could CRENESSITY treatment improve androgen control in 4 weeks?
                    </li>
                    <li className={styles.question}>
                      <strong>Question 2:</strong> Could CRENESSITY treatment enable personalized GC dose reduction to a physiologic range in 28 weeks while maintaining or improving androstenedione levels?
                    </li>
                    <li className={styles.question}>
                      <strong>Question 3:</strong> Does long-term treatment with CRENESSITY improve clinical outcomes?
                    </li>
                  </ul>
                  <CustomImage
                    src="/images/page/hcp/clinical-information/Clinical-Information_Clinical-Trial-Pediatric.png"
                    width={140}
                    height={140}
                    alt=""
                    className={styles.icon}
                  />
                </div>
                {/* <p className={styles.trial_info}>
                  Trial included 103 pediatric patients (aged 4 to 17 years).
                </p> */}
              </div>
              </Button>
            </div>

            <div className={styles.card_wrapper}>
              <Button
                href="/clinical-information#trial-2-efficacy"
                data-gtm-event-category="Action"
                data-gtm-event-action="Click"
                data-gtm-event-label="CAHtalyst Adult GC Reduction Card"
              >
                <div className={`${styles.card} ${currentTabIndex === 0 && styles.card_white}`}>
                  <div className={styles.title_group}>
                    <h3 className={styles.trial_title}>CAHtalyst<sup>&reg;</sup> Adult:<br/> Protocolized GC Dose Reduction<sup>1,7,10</sup>
                    </h3>
                  </div>
                  <div className={styles.content_wrapper}>
                    <ul className={styles.questions}>
                      <li className={styles.question}>
                        <strong>Question 1:</strong> Could CRENESSITY treatment improve androgen control in 4 weeks?
                      </li>
                      <li className={styles.question}>
                        <strong>Question 2:</strong> Could CRENESSITY treatment enable protocolized GC dose reduction to a physiologic range in 24 weeks while maintaining or improving androstenedione levels?
                      </li>
                      <li className={styles.question}>
                        <strong>Question 3:</strong> Does long-term treatment with CRENESSITY improve clinical outcomes?
                      </li>
                    </ul>
                    <CustomImage
                      src="/images/page/hcp/clinical-information/Clinical-Information_Clinical-Trial-Adult.png"
                      width={140}
                      height={140}
                      alt=""
                      className={styles.icon}
                    />
                  </div>
                  {/* <p className={styles.trial_info}>
                    Trial included 182 adult patients (aged 18 to 58 years).
                  </p> */}
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className={styles.mobile_view}>
        <div className="container">
          <div className={styles.accordion}>
            <button 
              className={styles.accordion_button}
              onClick={() => toggleAccordion(0)}
            >
              <div className={styles.accordion_header}>
                <div>
                  <h3 className={styles.mobile_title}>CAHtalyst<sup>&reg;</sup> Pediatric: <br />Personalized GC Dose Reduction<sup>1,6,9</sup></h3>
                </div>
                <span className={`${styles.chevron} ${openAccordion === 0 ? styles.open : ''}`}>
                  <CustomImage
                    src="/images/page/hcp/clinical-information/chevron-down.svg"
                    width={32}
                    height={18}
                    alt=""
                  />
                </span>
              </div>
            </button>
            <div 
              className={styles.accordion_content}
              data-open={openAccordion === 0}
            >
              <div className={styles.content_wrapper}>
                <ul className={styles.questions}>
                  <li className={styles.question}>
                    <strong>Question 1:</strong> Could CRENESSITY treatment improve androgen control in 4 weeks?
                  </li>
                  <li className={styles.question}>
                  <strong>Question 2:</strong> Could CRENESSITY treatment enable personalized GC dose reduction to a physiologic range in 28 weeks while maintaining or improving androstenedione levels?
                  </li>
                  <li className={styles.question}>
                    <strong>Question 3:</strong> Does long-term treatment with CRENESSITY improve clinical outcomes?
                  </li>
                </ul>
                <CustomImage
                  src="/images/page/hcp/clinical-information/Clinical-Information_Clinical-Trial-Pediatric.png"
                  width={140}
                  height={140}
                  alt=""
                  className={styles.icon}
                />
              </div>
              {/* <p className={styles.trial_info}>
                Trial included 103 pediatric patients (aged 4 to 17 years).
              </p> */}
            </div>

            <button 
              className={styles.accordion_button}
              onClick={() => toggleAccordion(1)}
            >
              <div className={styles.accordion_header}>
                <div>
                  <h3 className={styles.mobile_title}>CAHtalyst<sup>&reg;</sup> Adult: <br />Protocolized GC Dose Reduction<sup>1,7,10</sup></h3>
                </div>
                <span className={`${styles.chevron} ${openAccordion === 1 ? styles.open : ''}`}>
                  <CustomImage
                    src="/images/page/hcp/clinical-information/chevron-down.svg"
                    width={32}
                    height={18}
                    alt=""
                  />
                </span>
              </div>
            </button>
            <div 
              className={styles.accordion_content}
              data-open={openAccordion === 1}
            >
              <div className={styles.content_wrapper}>
                <ul className={styles.questions}>
                  <li className={styles.question}>
                  <strong>Question 1:</strong> Could CRENESSITY treatment improve androgen control in 4 weeks?
                  </li>
                  <li className={styles.question}>
                  <strong>Question 2:</strong> Could CRENESSITY treatment enable protocolized GC dose reduction to a physiologic range in 24 weeks while maintaining or improving androstenedione levels?
                  </li>
                  <li className={styles.question}>
                    <strong>Question 3:</strong> Does long-term treatment with CRENESSITY improve clinical outcomes?
                  </li>
                </ul>
                <CustomImage
                  src="/images/page/hcp/clinical-information/Clinical-Information_Clinical-Trial-Adult.png"
                  width={140}
                  height={140}
                  alt=""
                  className={styles.icon}
                />
              </div>
              {/* <p className={styles.trial_info}>
                Trial included 182 adult patients (aged 18 to 58 years).
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}